import Button, { Props as ButtonProps } from 'components/Button/Button';
import useRefreshDelay from 'hooks/useRefreshDelay';
import { useTranslation } from 'react-i18next';

interface Props extends Omit<ButtonProps, 'onClick' | 'children'> {
  delaySeconds: number;
  onRefresh: () => void;
  text?: string;
}

export default function RefreshButton({
  delaySeconds,
  onRefresh,
  text,
  disabled,
  ...buttonProps
}: Props) {
  const { isDisabled, remainingSeconds, handleRefresh } = useRefreshDelay({
    delaySeconds,
    onRefresh,
  });
  const { t } = useTranslation(['welcome_back', 'common', 'time']);

  const isButtonDisabled = disabled || isDisabled;

  return (
    <div className="flex flex-col items-center">
      <span className="text-muted h-7">
        {isButtonDisabled && (
          <>
            {`${t('check_again_in')} ${t('time:seconds', { count: remainingSeconds })}`}
          </>
        )}
      </span>
      <Button
        {...buttonProps}
        disabled={isButtonDisabled}
        onClick={handleRefresh}
      >
        {text}
      </Button>
    </div>
  );
}
